module.exports = __webpack_public_path__ + "img/issue-icon4.326cbcd.png";